import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/app/projects/ProjectsClient.tsx");
